import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import NebulaModuleBase from './module-base';
export var UpResource = function (_NebulaModuleBase) {
    _inherits(UpResource, _NebulaModuleBase);

    function UpResource() {
        _classCallCheck(this, UpResource);

        return _possibleConstructorReturn(this, (UpResource.__proto__ || Object.getPrototypeOf(UpResource)).apply(this, arguments));
    }

    _createClass(UpResource, [{
        key: 'updateCommonResList',
        value: function updateCommonResList(params) {
            return this.generatePromiseByFunctionWithParams('requestNormalResListForResource', params);
        }
    }, {
        key: 'updateDeviceResList',
        value: function updateDeviceResList(params) {
            return this.generatePromiseByFunctionWithParams('requestDeviceResListForResource', params);
        }
    }, {
        key: 'getEntireList',
        value: function getEntireList(params) {
            return this.generatePromiseByFunctionWithParams('getEntireListForResource', params);
        }
    }, {
        key: 'getLatestList',
        value: function getLatestList(params) {
            return this.generatePromiseByFunctionWithParams('getLatestListForResource', params);
        }
    }, {
        key: 'install',
        value: function install(data, callback) {
            var event = 'InstallCallBack_' + data.name + data.type + data.version;
            this.generatePromiseByAttachListenerWithParams(event, callback);
            var params = {
                eventName: event,
                name: data.name,
                type: data.type,
                version: data.version
            };
            return this.generatePromiseByFunctionWithParams('installForResource', params);
        }
    }, {
        key: 'uninstall',
        value: function uninstall(data, callback) {
            var event = 'UnInstallCallBack_' + data.name + data.type + data.version;
            this.generatePromiseByAttachListenerWithParams(event, callback);
            var params = {
                eventName: event,
                name: data.name,
                type: data.type,
                version: data.version
            };
            return this.generatePromiseByFunctionWithParams('uninstallForResource', params);
        }
    }, {
        key: 'requestNormalResList',
        value: function requestNormalResList(params) {
            return this.generatePromiseByFunctionWithParams('requestNormalResListForResource', params);
        }
    }, {
        key: 'searchNormalResList',
        value: function searchNormalResList(params) {
            return this.generatePromiseByFunctionWithParams('searchNormalResListForResource', params);
        }
    }, {
        key: 'getCommonRes',
        value: function getCommonRes(data, callback) {
            var event = 'GetCommonResCallBack_' + data.name + data.type;
            this.generatePromiseByAttachListenerWithParams(event, callback);
            var params = {
                eventName: event,
                name: data.name,
                type: data.type
            };
            return this.generatePromiseByFunctionWithParams('getCommonResForResource', params);
        }
    }, {
        key: 'requestDeviceResList',
        value: function requestDeviceResList(params) {
            return this.generatePromiseByFunctionWithParams('requestDeviceResListForResource', params);
        }
    }, {
        key: 'searchDeviceResList',
        value: function searchDeviceResList(params) {
            return this.generatePromiseByFunctionWithParams('searchDeviceResListForResource', params);
        }
    }, {
        key: 'getDeviceRes',
        value: function getDeviceRes(data, callback) {
            var event = 'GetDeviceResCallBack_' + data.typeId + data.type + data.model + data.prodNo + data.deviceNetType + data.deviceType;
            this.generatePromiseByAttachListenerWithParams(event, callback);
            var params = {
                eventName: event,
                typeId: data.typeId,
                type: data.type,
                model: data.model,
                prodNo: data.prodNo,
                deviceNetType: data.deviceNetType,
                deviceType: data.deviceType
            };
            return this.generatePromiseByFunctionWithParams('getDeviceResForResource', params);
        }
    }]);

    return UpResource;
}(NebulaModuleBase);